import { useInfiniteQuery } from '@tanstack/react-query';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { ArticlesListParams } from '@src/api/articles.ts';
import { API } from '@src/api/index.ts';

export const useArticlesInfiniteQuery = (params: Omit<ArticlesListParams, 'page' | 'module'>) => {
  const { moduleId } = useModuleByCodeParam();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['articles', { ...params, moduleId }],
    queryFn: async ({ pageParam = 1 }) =>
      await API.articles.getList({
        ...params,
        tabName: params.tabName ?? 'all',
        page: pageParam,
        module: moduleId,
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { next } = lastPage;
      return next ? lastPageParam + 1 : undefined;
    },
    select: (data) => {
      return {
        ...data,
        results: data?.pages.flatMap((page) => page.results),
      };
    },
  });
};
